import { Action, createReducer, on } from "@ngrx/store";
import { PlanState } from "./plan.state";
import * as mobileActions from "./mobile/mobile.actions";
import { MOBILE_OBJ } from "../../shared/name/name.library";

const initialState: PlanState = null;

const featureReducer = createReducer(
	initialState,
	on(mobileActions.setBaseMobilePlan, (state, { planIdentifier }) => {
		const mobile = {
			...state?.mobile,
			base: planIdentifier,
			addons: state?.mobile?.addons,
		};
		return {
			...state,
			mobile,
		};
	}),
	on(mobileActions.setSelectedBaseMobilePlan, (state, { plan }) => {
		return {
			...state,
			mobile: {
				...state.mobile,
				selectedPlan: plan,
			},
		};
	}),
	on(mobileActions.setAddonsMobilePlan, (state, { addons }) => {
		const mobile = {
			base: state?.mobile?.base,
			addons,
		};
		return {
			...state,
			mobile,
		};
	}),
	on(
		mobileActions.setProductOfferingMobilePlan,
		(state, { productOffering }) => {
			return {
				...state,
				mobile: {
					...state?.mobile,
					productOffering,
					view: MOBILE_OBJ.plan.view.base,
				},
			};
		}
	),
	on(mobileActions.setQuoteMobilePlan, (state: any, { quote }) => {
		if (state?.mobile?.quote?.quoteNumber && !quote?.quoteNumber) {
			quote = {
				...quote,
				quoteNumber: state?.mobile?.quote?.quoteNumber,
				id: state?.mobile?.quote?.id,
			};
		} else {
			quote = {
				...quote,
				quoteNumber: quote?.quoteNumber,
				id: quote?.id,
			};
		}
		return {
			...state,
			mobile: {
				...state?.mobile,
				quote,
			},
		};
	}),
);

export function planReducer(
	state: PlanState | undefined,
	action: Action
): PlanState | undefined {
	return featureReducer(state, action);
}
